module.exports = __webpack_public_path__ + "img/Risk_Rate_v1_24.25b5041d.png";